'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AdBanner from '@/components/AdBanner';
import BoardList from '@/components/BoardList';

/**
 * Hauliers Directory
 *
 * The body is BoardList, reading entries the FarmTradeDirect team adds in
 * Admin -> Boards. This page previously held a hardcoded array of eight invented haulage firms, with invented contacts, ratings and email addresses.
 */
export default function HauliersDirectoryScreen() {
  return (
    <main className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 py-8">
      <div className="mb-8">
        <h1 className="text-2xl md:text-3xl font-extrabold text-foreground">Hauliers Directory</h1>
        <p className="text-muted-foreground text-sm mt-2 max-w-2xl leading-relaxed">
          Livestock and machinery hauliers working across the UK. Enquiries come to the FarmTradeDirect team, who will pass you on to the right operator.
        </p>
      </div>

      <div className="flex items-start gap-3 bg-blue-50 border border-blue-200 rounded-xl px-5 py-4 mb-6">
        <Icon name="InformationCircleIcon" size={20} className="text-blue-600 shrink-0 mt-0.5" />
        <p className="text-sm text-blue-900">Are you a haulier who wants to be listed? Send an enquiry on any entry below, or use the contact page, and we will get you added.</p>
      </div>


      <BoardList
        board="hauliers"
        emptyTitle="The directory is being built"
        emptyMessage="We are adding hauliers as they are checked. Rather than fill this page with names we have not verified, it stays empty until there is something real on it."
        enquiryLabel="Enquire about this haulier"
        showCoverage
      />

      <div className="mt-10">
        <AdBanner width={728} height={90} label="728x90 Leaderboard Banner" className="mx-auto rounded-lg" />
      </div>
    </main>
  );
}
